import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';

const getLogoClassName = () => `hz-SvgAsset hz-SvgAssetTenant--${GDPRConfig.locale.toLowerCase().replace('-', '')}`;

export default getLogoClassName;
